// getters.js

export default {
    getControllerList(state){
        return state.controllerList
    },
};
